import React, { useState, useEffect } from "react";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import AddIcon from "@mui/icons-material/Add";
import { Button, IconButton, Input, Tooltip } from "@mui/material";
import { FormControlLabel } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Autocomplete from "@mui/material/Autocomplete";
import useSave from "../../../../Hooks/useSave";
import BasicTable from "../../../../components/InfoDisplay/InfoDisplay";
import Switch from "@mui/material/Switch";
import { useRef } from "react";
import { useNavigate } from "react-router-dom";

export default function NewOrder() {
  const { fetchGraphql, DialogSave } = useSave();
  const navigate = useNavigate();

  //create date
  const date = new Date();
  const est1 = new Date(date.getTime() + -240 * 60 * 1000);
  const tomorow = new Date(est1);
  tomorow.setDate(date.getDate() + 1);

  const [customersOptions, setCustomersOptions] = useState([]);
  const [order, setOrder] = useState({
    deliveryDate: tomorow,
  });
  const [products, setProducts] = useState([]);
  const [productsOptions, setProductsOptions] = useState([]);
  const [orderByCode, setOrderByCode] = useState(false);
  const [focus, setFocus] = useState(false);
  const element = useRef();

  useEffect(() => {
    fetchGraphql({
      query: `query Products {
        products {
          productName
          productId
          productCode
          productPrice
        }
      }`,
    }).then((result) => setProductsOptions(result.data.products));

    return () => {};
  }, []);

  useEffect(() => {
    fetchGraphql({
      query: `query Customers {
        customers {
          customerName
          customerId
        }
      }`,
    }).then((result) =>
      setCustomersOptions(
        result.data.customers.map((item) => ({
          ...item,
          label: item.customerName,
        }))
      )
    );

    return () => {};
  }, []);

  useEffect(() => {
    element?.current?.lastChild.firstChild.focus();

    return setFocus(false);
  }, [focus]);

  const columns = [
    {
      id: "productCode",
      name: "Product Code",
      edit: !orderByCode,
      customInput: (row, rowIndex, columnIndex) => (
        <Autocomplete
          disablePortal
          key="1"
          // ref={element}
          options={productsOptions.map((item) => ({
            ...item,
            label: item.productCode,
          }))}
          autoSelect={true}
          autoHighlight={true}
          // value={row.productCode}
          onHighlightChange={(event, value) => {
            // console.log("fired");
            const copyState = [...products];

            copyState[rowIndex] = value || [];

            setProducts(copyState);
          }}
          onChange={(event, value) => {
            // console.log("fired");
            const copyState = [...products];

            copyState[rowIndex] = value || [];

            setProducts(copyState);
          }}
          sx={{ width: 250, marginRight: "10px" }}
          renderInput={(params) => (
            <TextField {...params} ref={element} key="5" label="Product Code" />
          )}
        />
      ),
    },
    {
      id: "productName",
      name: "Product Name",
      edit: orderByCode,
      customInput: (row, index) => (
        <Autocomplete
          disablePortal
          key="2"
          autoSelect={true}
          autoHighlight={true}
          options={productsOptions.map((item) => ({
            ...item,
            label: item.productName,
          }))}
          onChange={(event, value) => {
            setProducts((products) => {
              const copyState = [...products];

              // console.log(copyState);

              copyState[index] = value || [];

              return copyState;
            });
          }}
          sx={{ width: 250, marginRight: "10px" }}
          renderInput={(params) => (
            <TextField
              {...params}
              autofocus={true}
              ref={element}
              key="2"
              label="Product name"
            />
          )}
        />
      ),
    },
    {
      id: "productPrice",
      name: "Price Per Unit",
      edit: false,
    },
    {
      id: "quantity",
      name: "Quantity",
      edit: true,
    },
    {
      id: "totalPrice",
      name: "Total Price",
      edit: false,
    },
  ];

  const options = {
    focusIndex: 2,
    handleEdit: (e, row, columnId, index) => {
      // console.log("handle edit");
      setProducts((rows) => {
        const copyState = [...rows];

        // console.log(Number(e.target.value));

        if (columnId === "quantity") {
          copyState[index][columnId] = Number(e.target.value);
        } else {
          copyState[index][columnId] = e.target.value;
        }

        return copyState;
      });
    },
    handleDontSave: (originalRow, index) => {
      setProducts((rows) => {
        const copyState = [...rows];

        copyState[index] = originalRow;

        return copyState;
      });
    },
    addRecord: () => {
      setFocus(true);
      setProducts((rows) => [
        ...rows,
        {
          productCode: "",
          productName: "",
          productPrice: "",
          orderedQuantity: "",
          totalPrice: "",
        },
      ]);
    },
    handleDelete: (row, index) =>
      setProducts((rows) => {
        const copyState = [...rows];

        copyState.splice(index, 1);

        return copyState;
      }),
  };

  return (
    <Paper
      sx={{
        height: "80vh",
        minHeight: "300px",
        padding: "25px",
        overflowY: "auto",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {<DialogSave />}
      <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Autocomplete
            disablePortal
            autoSelect={true}
            autoHighlight={true}
            options={customersOptions}
            onChange={(event, value) =>
              setOrder({
                ...order,
                customerId: value.customerId,
              })
            }
            sx={{ width: 250, marginRight: "10px" }}
            renderInput={(params) => (
              <TextField {...params} label="Customer Name" />
            )}
          />
        </Box>

        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <DatePicker
              label="Delivery Date"
              openTo="day"
              views={["year", "month", "day"]}
              shouldDisableDate={(date) => {
                const today = new Date();
                const todayDate = new Date(date);

                if (date < today.setDate(today.getDate())) return true;

                if (todayDate.getDay() === 6) return true;
              }}
              value={order.deliveryDate || tomorow}
              onChange={(newValue) => {
                setOrder({
                  ...order,
                  deliveryDate: newValue,
                });
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </LocalizationProvider>
        </Box>

        <Tooltip title={orderByCode ? "Order By Code" : "Order By Product"}>
          <Switch onChange={(e) => setOrderByCode(e.target.checked)} />
        </Tooltip>

        <Button
          sx={{ marginLeft: "auto" }}
          variant="contained"
          onClick={() => {
            fetchGraphql({
              query: `mutation CreateOrder($order: orderInput, $products: [orderProductInput]) {
                createOrder(order: $order, products: $products)
              }`,
              variables: {
                products: products.map((item) => ({
                  productId: item.productId,
                  quantity: item.quantity,
                })),
                order,
              },
            }).then((result) =>
              navigate(`/orders/order/${result.data.createOrder}/order`)
            );
          }}
        >
          Submit order
        </Button>
      </Box>

      <TextField
        sx={{ margin: "10px 0px", width: "508px" }}
        multiline
        onChange={(e) =>
          setOrder({
            ...order,
            orderNote: e.target.value,
          })
        }
        label="Order Note"
        value={order.orderNote || null}
        color="primary"
      />

      <Box sx={{ marginTop: "20px" }}>
        <BasicTable
          columns={columns}
          key="3"
          rows={products.map((item, index) => ({
            ...item,
            totalPrice:
              item.productPrice && item.orderedQuantity
                ? item.productPrice * item.orderedQuantity
                : null,
          }))}
          header="Products"
          options={options}
        />
      </Box>
    </Paper>
  );
}
